import EmptyData from './EmptyData'

export default EmptyData
